<template>
  <div>
    <datatable
      @create="createText"
      title="Applicant Texts"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicant-texts',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'content',
          value: 'content'
        }
      ],
      data: [],
      operations: [],
      applicant_id: this.$route.query.applicant_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceTexts({
          current_type: 'Applicant',
          current_resource_id: this.applicant_id
        })
        .then(response => {
          this.data = response
        })
    },
    createText () {
      this.create({ designator: 'applicant-texts-form-modal', component_name: 'TextsForm', is_create: true, resource_type: 'Applicant', resource_id: this.applicant_id, modal_title: 'Create new Text' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-texts-form-modal', component_name: 'TextsForm', data, resource_type: 'Applicant', resource_id: this.applicant_id, modal_title: data.designator })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
